import type { AllRouteEndpoints } from "../routeTypes";
export const alloysPartnerCohortImportAppGroupId = "/alloys/:partner/cohort_import/:app_group_id";

export const postAlloysPartnerCohortImportAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysPartnerCohortImportAppGroupId,
];
